<div class="block-wrapper" [ngClass]="[block.styles.justify, 'd-flex', 'flex-row']">
  <button [ngClass]="block.classes" (click)="onClick($event)" [class.no-disabled]="blocksConfig.editable"
          [disabled]="sessionController?.loading | async" type="button"
          [style.background-color]="block.styles.background" [style.color]="block.styles.fontcolor">
    {{(block.settings.name && block.settings.name.length > 0) ? block.settings.name : 'Button'}}
  </button>
</div>
